import $ from "jquery";
const PATH = "api:///v4/support";
const getSupport = () => $.ajax({
    method: "GET",
    url: PATH,
});
const editSupport = (data) => $.ajax({
    method: "PUT",
    url: PATH,
    contentType: "application/json",
    data: JSON.stringify(data),
});
export default {
    getSupport,
    editSupport,
};
